<template>
  <div>
    <div
      class="mb-0 py-4"
      v-if="showType == 'form-builder'"
      :style="properties.style"
      style="font-size:14px"
    >
      Treatment Plan Objectives
    </div>
    <div v-if="showType == 'properties'">
      <treatment-plan-objectives-v1-properties :formId="formId" />
    </div>
    <!-- <div
      class="mb-0"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
    > -->
    <div
      class="mb-0"
      v-if="showType == 'form-submitter'"
      :style="properties.style"
      v-show="!computedHidden"
    >
      <b-form-group label="Select Treatment Plan" style="max-width: 550px;font-size:14px;">
        <v-select
          style="font-size:14px;"
          v-model="masterTreatmentPlanDocument"
          :options="masterTreatmentPlanDocumentOptions"
        ></v-select>
      </b-form-group>
      <div v-if="masterTreatmentPlanForm && masterTreatmentPlanDocument">
        <div class="d-flex justify-content-between align-items-center">
          <span style="font-size:14px">Select Objectives</span>
          <!-- <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            @click="reloadObjectives"
            ><i class="fa fa-sync-alt mr-2"></i> Reload Objectives</b-button
          > -->
        </div>
        <b-container class="mt-2 border">
          <div
            v-for="(problem, problemIndex) in problemObjectives"
            :key="problemIndex"
          >
            <b-row class="py-2 bg-extra-light-gray" style="font-size:13px;">
              <b-col>
                <div><strong>Problem:</strong> {{ problem.problem }}</div>
                <div>
                  <strong>Identified Problem:</strong>
                  {{ problem.identifiedProblem }}
                </div>
                <div>
                  <strong>Long-Term Goal:</strong> {{ problem.longTermGoal }}
                </div>
              </b-col>
            </b-row>
            <b-row class="border-bottom py-2" style="font-size:14px;">
              <b-col>
                <strong>Objective</strong>
              </b-col>
              <b-col>
                <strong>Interventions</strong>
              </b-col>
              <b-col>
                <strong>Responsible Parties</strong>
              </b-col>
              <b-col>
                <strong>Details</strong>
              </b-col>
            </b-row>
            <b-row
              v-for="(objective, objectiveIndex) in problem.objectives"
              :key="objectiveIndex"
              class="border-bottom"
              style="font-size:12px;"
            >
              <b-col>
                <b-form-checkbox
                  size="sm"
                  class="treament-objective-checkbox"
                  v-model="objectiveSelected"
                  :value="`problem_${problemIndex}_objective_${objectiveIndex}`"
                  style="font-size:12px;"
                  ><span style="padding-top: 3px;">{{
                    objective.shortTermMeasurableObjective
                  }}</span></b-form-checkbox
                >
              </b-col>
              <b-col style="padding-top: 3px;">
                <span>{{ objective.interventions }}</span>
              </b-col>
              <b-col style="padding-top: 3px;">
                <span>{{ objective.responsibleParties }}</span>
              </b-col>
              <b-col style="padding-top: 3px; padding-bottom: 3px;">
                <b-textarea
                  v-if="
                    objectiveSelected.includes(
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    )
                  "
                  :value="
                    objectiveDetails[
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    ]
                      ? objectiveDetails[
                          `problem_${problemIndex}_objective_${objectiveIndex}`
                        ]
                      : ''
                  "
                  @input="
                    newValue =>
                      setObjectiveDetails(
                        `problem_${problemIndex}_objective_${objectiveIndex}`,
                        newValue
                      )
                  "
                ></b-textarea>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
    <div
      class="mb-0"
      v-if="showType == 'form-viewer'"
      :style="properties.style"
    >
      <b-form-group label="Treatment Plan">
        <span style="font-size:14px">{{
          masterTreatmentPlanDocument.label
        }}</span>
      </b-form-group>
      <div v-if="masterTreatmentPlanForm && masterTreatmentPlanDocument">
        <div class="d-flex justify-content-between align-items-center">
          <span style="font-size:14px">Objectives</span>
          <!-- <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            @click="reloadObjectives"
            ><i class="fa fa-sync-alt mr-2"></i> Reload Objectives</b-button
          > -->
        </div>
        <b-container class="mt-2 border">
          <div
            v-for="(problem, problemIndex) in problemObjectives"
            :key="problemIndex"
          >
            <div
              v-if="
                problem.objectives.filter((objective, objectiveIndex) =>
                  objectiveSelected.includes(
                    `problem_${problemIndex}_objective_${objectiveIndex}`
                  )
                ).length > 0
              "
            >
              <b-row class="py-2 bg-extra-light-gray" style="font-size:13px;">
                <b-col>
                  <div><strong>Problem:</strong> {{ problem.problem }}</div>
                  <div>
                    <strong>Identified Problem:</strong>
                    {{ problem.identifiedProblem }}
                  </div>
                  <div>
                    <strong>Long-Term Goal:</strong> {{ problem.longTermGoal }}
                  </div>
                </b-col>
              </b-row>
              <b-row class="border-bottom py-2" style="font-size:14px;">
                <b-col>
                  <strong>Objective</strong>
                </b-col>
                <b-col>
                  <strong>Interventions</strong>
                </b-col>
                <b-col>
                  <strong>Responsible Parties</strong>
                </b-col>
                <b-col>
                  <strong>Details</strong>
                </b-col>
              </b-row>
            </div>
            <div
              v-for="(objective, objectiveIndex) in problem.objectives"
              :key="objectiveIndex"
            >
              <b-row
                v-if="
                  objectiveSelected.includes(
                    `problem_${problemIndex}_objective_${objectiveIndex}`
                  )
                "
                class="py-2 border-bottom"
                style="font-size:12px;"
              >
                <b-col>
                  <b-icon-check-square-fill
                    class="text-primary"
                    v-if="
                      objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                    "
                  /><b-icon-square v-else />
                  {{ objective.shortTermMeasurableObjective }}
                </b-col>
                <b-col>
                  {{ objective.interventions }}
                </b-col>
                <b-col>
                  {{ objective.responsibleParties }}
                </b-col>
                <b-col>
                  <div
                    v-if="
                      objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                    "
                  >
                    {{
                      objectiveDetails[
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      ]
                        ? objectiveDetails[
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          ]
                        : ""
                    }}
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { formatDate, formatDateTimeMysql } from "../../../../helpers/date";
import formSubmitterServer from "../../../../server/formSubmitter";
import eFormServer from "../../../../server/eForm";
import TreatmentPlanObjectivesV1Properties from "./TreatmentPlanObjectivesV1Properties";
import { valueOrOther } from "../../../../helpers/formBuilder";
export default {
  name: "TreatmentPlanObjectivesV1",
  components: { TreatmentPlanObjectivesV1Properties },
  props: ["showType", "properties", "form", "id", "formId"],
  data() {
    return {
      computedProperties: ["hidden"],
      computedConditions: {},
      masterTreatmentPlanForm: null,
      masterTreatmentPlanDocumentOptions: []
    };
  },
  async mounted() {
    if (this.showType != "e-form") {
      this.computeConditions();
      if (this.showType == "form-submitter" || this.showType == "form-viewer")
        await this.fetchData();
      if (
        this.showType == "form-submitter" ||
        (this.showType == "e-form" && this.properties.eFormEditable)
      ) {
        this.getFormSubmitsOptions();
      }
    }
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async fetchData() {
      await this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
      this.masterTreatmentPlanForm = await this.getFormBuilderFormById(
        this.masterTreatmentPlanFormId
      );
    },
    async getFormSubmitsOptions() {
      let submits = [];
      if (this.showType == "e-form") {
        /* submits = await eFormServer.querySubmits(
          this.$route.params.token,
          this.masterTreatmentPlanFormId,
          this.client.episodeOfCare.id
        ); */
      } else {
        submits = await formSubmitterServer.query(
          this.masterTreatmentPlanFormId,
          this.client.id,
          this.client.episodeOfCare.id
        );
      }

      this.masterTreatmentPlanDocumentOptions = submits.map(submit => ({
        value: submit.id,
        label: `${formatDate(submit.createdAt)} by ${
          submit.createdBy ? this.formatUser(submit.createdBy) : "-"
        }`,
        data: submit
      }));
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          Options: this.masterTreatmentPlanDocumentOptions
        }
      });
    },
    async reloadObjectives() {
      const submit = await this.getFormSubmitById(
        this.controlValue.document.id
      );
      const filteredSubmit = {
        id: submit.id,
        status: submit.status,
        versionId: submit.versionId,
        createdAt: submit.createdAt,
        createdBy: {
          id: submit.createdBy.id,
          fullName: this.formatUser(submit.createdBy),
          credentials: submit.createdBy.credentials
        },
        mode: submit.mode,
        results: submit.results,
        score: submit.score,
        effectiveDate: submit.effectiveDate
      };
      this.masterTreatmentPlanDocument = {
        value: filteredSubmit.id,
        label: `${formatDate(filteredSubmit.createdAt)} by ${
          filteredSubmit.createdBy
            ? this.formatUser(filteredSubmit.createdBy)
            : "-"
        }`,
        data: filteredSubmit
      };
      this.problemObjectives = await this.getProblems();
      this.objectiveSelected = [];
      this.objectiveDetails = {};
    },
    setObjectiveDetails(objective, newValue) {
      const newObjectiveDetails = { ...this.objectiveDetails };
      newObjectiveDetails[objective] = newValue;
      this.objectiveDetails = newObjectiveDetails;
    },
    async getProblems() {
      let treatmentPlanObjectivesMap = JSON.parse(
        this.masterTreatmentPlanForm.current.content.properties
          .treatmentPlanObjectivesMap
      );
      let results = this.masterTreatmentPlanDocument.data.results;

      let submits = [];
      if (this.showType == "e-form") {
        submits = await eFormServer.querySubmits(
          this.$route.params.token,
          this.masterTreatmentPlanFormId,
          this.client.episodeOfCare.id
        );
      } else {
        submits = await formSubmitterServer.query(
          this.masterTreatmentPlanFormId,
          this.client.id,
          this.client.episodeOfCare.id
        );
      }
      submits = submits.filter(
        submit =>
          submit.parentDocumentId == this.masterTreatmentPlanDocument.data.id
      );
      if (submits.length > 0) {
        submits.sort((s1, s2) =>
          formatDateTimeMysql(s2.effectiveDate).localeCompare(
            formatDateTimeMysql(s1.effectiveDate)
          )
        );
        results = submits[0].results;
        treatmentPlanObjectivesMap = JSON.parse(
          this.masterTreatmentPlanForm.current.content.properties
            .treatmentPlanObjectivesMap
        );
      }
      return results[treatmentPlanObjectivesMap.ProblemsCrudId].map(
        (problem, problemIndex) => {
          return {
            problem: valueOrOther(
              problem[treatmentPlanObjectivesMap.ProblemId + "_0"]
            ),
            identifiedProblem: valueOrOther(
              problem[treatmentPlanObjectivesMap.IdentifiedProblemId + "_0"]
            ),
            longTermGoal: valueOrOther(
              problem[treatmentPlanObjectivesMap.LongTermGoalId + "_0"]
            ),
            objectives: results[
              treatmentPlanObjectivesMap.ObjectivesCrudId +
                "_" +
                (problemIndex + 1)
            ].map(objective => {
              return {
                shortTermMeasurableObjective: valueOrOther(
                  objective[
                    treatmentPlanObjectivesMap.ShortTermMeasurableObjectiveId +
                      "_" +
                      (problemIndex + 1) +
                      "_0"
                  ]
                ),
                interventions: objective[
                  treatmentPlanObjectivesMap.InterventionsId +
                    "_" +
                    (problemIndex + 1) +
                    "_0"
                ]
                  ? objective[
                      treatmentPlanObjectivesMap.InterventionsId +
                        "_" +
                        (problemIndex + 1) +
                        "_0"
                    ].value.join(", ")
                  : "",
                responsibleParties: objective[
                  treatmentPlanObjectivesMap.ResponsiblePartiesId +
                    "_" +
                    (problemIndex + 1) +
                    "_0"
                ]
                  ? objective[
                      treatmentPlanObjectivesMap.ResponsiblePartiesId +
                        "_" +
                        (problemIndex + 1) +
                        "_0"
                    ].value.join(", ")
                  : ""
              };
            })
          };
        }
      );
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <div class="mb-0" style="${this.getComponentComputedProperties("style")}">
        <fieldset aria-describedby="" class="form-group">
          <legend style="font-size:14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" >Treatment Plan</legend>
          <div tabindex="-1" role="group" class="bv-no-focus-ring"><span style="font-size: 14px;">${
            this.masterTreatmentPlanDocument
              ? this.masterTreatmentPlanDocument.label
              : ""
          }</span>
          </div>
        </fieldset>
        ${
          this.masterTreatmentPlanForm && this.masterTreatmentPlanDocument
            ? `
          <div>
            <div class="d-flex justify-content-between align-items-center"><span style="font-size: 14px;">Objectives</span></div>
            <div class="mt-2 border container">
              ${this.problemObjectives
                .map(
                  (problem, problemIndex) => `
                <div>
                ${
                  problem.objectives.filter((objective, objectiveIndex) =>
                    this.objectiveSelected.includes(
                      `problem_${problemIndex}_objective_${objectiveIndex}`
                    )
                  ).length > 0
                    ? `
                  <div>
                    <div class="row py-2 bg-extra-light-gray" style="font-size: 13px;">
                      <div class="col">
                        <div><strong>Problem:</strong> ${problem.problem}</div>
                        <div><strong>Identified Problem:</strong> ${problem.identifiedProblem} </div>
                        <div><strong>Long-Term Goal:</strong> ${problem.longTermGoal} </div>
                      </div>
                    </div>
                    <div class="row border-bottom py-2" style="font-size: 14px;">
                      <div class="col"><strong>Objective</strong></div>
                      <div class="col"><strong>Interventions</strong></div>
                      <div class="col"><strong>Responsible Parties</strong></div>
                      <div class="col"><strong>Details</strong></div>
                    </div>
                  </div>
                  `
                    : ""
                }
                ${problem.objectives
                  .map(
                    (objective, objectiveIndex) => `
                  <div>
                    ${
                      this.objectiveSelected.includes(
                        `problem_${problemIndex}_objective_${objectiveIndex}`
                      )
                        ? `
                    <div class="row py-2 border-bottom" style="font-size: 12px;">
                      <div class="col">
                        ${
                          this.objectiveSelected.includes(
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          )
                            ? '<i class="fas fa-check-square text-primary"></i>'
                            : '<i class="far fa-square"></i>'
                        } ${objective.shortTermMeasurableObjective} </div>
                      <div class="col"> ${objective.interventions} </div>
                      <div class="col"> ${objective.responsibleParties} </div>
                      <div class="col">
                        ${
                          this.objectiveSelected.includes(
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          )
                            ? `
                        <div> ${
                          this.objectiveDetails[
                            `problem_${problemIndex}_objective_${objectiveIndex}`
                          ]
                            ? this.objectiveDetails[
                                `problem_${problemIndex}_objective_${objectiveIndex}`
                              ]
                            : ""
                        } </div>
                        `
                            : ""
                        }
                        
                      </div>
                    </div>
                    `
                        : ""
                    }
                    
                  </div>
                `
                  )
                  .join("")}
                
              </div>
              `
                )
                .join("")}
              
            </div>
          </div>
          `
            : ""
        }
        
      </div>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      client: state => state.form.client
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "getFormSubmitById",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    ...mapGetters("client", ["selectedLocation"]),
    masterTreatmentPlanFormId() {
      return this.selectedLocation.treatmentPlanFormId;
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    masterTreatmentPlanDocument: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue
          ? {
              value: controlValue.document.id,
              label: `${formatDate(controlValue.document.createdAt)} by ${
                controlValue.document.createdBy
                  ? controlValue.document.createdBy.fullName
                  : "-"
              }`,
              data: controlValue.document
            }
          : null;
      },
      async set(newControlValue) {
        if (newControlValue) {
          const parsedControlValue = newControlValue.data;
          const filteredControlValue = {
            id: parsedControlValue.id,
            status: parsedControlValue.status,
            versionId: parsedControlValue.versionId,
            createdAt: parsedControlValue.createdAt,
            createdBy: {
              id: parsedControlValue.createdBy.id,
              fullName: this.formatUser(parsedControlValue.createdBy),
              credentials: parsedControlValue.createdBy.credentials
            },
            mode: parsedControlValue.mode,
            results: parsedControlValue.results,
            score: parsedControlValue.score,
            effectiveDate: parsedControlValue.effectiveDate
          };
          const newFomattedControlValue = {
            ...this.controlValue,
            document: filteredControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          this.problemObjectives = await this.getProblems();
          this.objectiveSelected = [];
          this.objectiveDetails = {};
        }
      }
    },
    problemObjectives: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.problemObjectives
          ? controlValue.problemObjectives
          : [];
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            problemObjectives: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    objectiveSelected: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.selectedObjectives
          ? controlValue.selectedObjectives
          : [];
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            selectedObjectives: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    objectiveDetails: {
      get() {
        let controlValue = {};
        if (this.results) controlValue = this.results[this.id];
        else controlValue = this.getFormSubmitterComponentValue(this.id);
        return controlValue && controlValue.objectiveDetails
          ? controlValue.objectiveDetails
          : {};
      },
      set(newControlValue) {
        if (newControlValue) {
          const newFomattedControlValue = {
            ...this.controlValue,
            objectiveDetails: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newFomattedControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
        }
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style>
.treament-objective-checkbox label {
  padding-top: 3px;
}
</style>
